import { render, staticRenderFns } from "./ModalSelecionaCalendario.vue?vue&type=template&id=319a747f"
import script from "./ModalSelecionaCalendario.vue?vue&type=script&lang=js"
export * from "./ModalSelecionaCalendario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports